import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslatePipe } from '@ngx-translate/core';
import { RepresentationTypes } from 'src/app/+models/shared.enums';
import { ModalComponent } from '../../common/modal/modal.component';

@Component({
  selector: 'app-representation-type-dialog',
  standalone: true,
  imports: [CommonModule, FormsModule, TranslatePipe, ModalComponent],
  templateUrl: './representation-type-dialog.component.html',
  styleUrl: './representation-type-dialog.component.scss',
})
export class RepresentationTypeDialogComponent {
  private translationKeyBase = 'registrationWizard.representateTypeModal.';
  private registrationTypesKey = 'registrationTypes.';
  protected modalTitle = `${this.translationKeyBase}registrationType`;
  protected selectedOption = RepresentationTypes.NATURAL_PERSON;
  protected dummyDate = new Date();

  protected registrationTypes = [
    {
      id: 'opt1',
      value: RepresentationTypes.NATURAL_PERSON,
      label: `${this.translationKeyBase}${this.registrationTypesKey}naturalPerson`,
    },
    {
      id: 'opt2',
      value: RepresentationTypes.LEGAL_PERSON,
      label: `${this.translationKeyBase}${this.registrationTypesKey}legalPerson`,
    },
    {
      id: 'opt3',
      value: RepresentationTypes.PROFESSIONAL_CLIENT,
      label: `${this.translationKeyBase}${this.registrationTypesKey}professionalClient`,
    },
  ];

  constructor(public activeModal: NgbActiveModal) {}

  protected handlePrimaryAction() {
    this.activeModal.close(this.selectedOption);
  }

  protected handleSecondaryAction() {
    this.activeModal.dismiss('canceled');
  }
}
